import { Injectable, signal } from '@angular/core';
import { AppNavItem } from './navigation.models';

@Injectable({
  providedIn: 'root',
})
export class NavigationRepositoryService {
  initMenuItems() {
    const items: AppNavItem[] = [
      {
        id: 'dashboard',
        label: 'Dashboard',
        type: 'link',
        path: '/dashboard',
        icon: '/svg/dashboard.svg',
        iconType: 'url',
        groups: ['user', 'admin', 'root'],
      },
      {
        id: 'quotes',
        label: 'Quotes',
        type: 'group',
        icon: 'analytics',
        iconType: 'font',
        groups: ['user', 'admin', 'root'],
        children: [
          {
            id: 'quotesList',
            label: 'Quotes',
            type: 'link',
            path: '/quotes/list',
            groups: ['user', 'admin', 'root'],
          },
          {
            id: 'divider-1',
            label: '',
            type: 'divider',
            groups: ['user', 'admin', 'root'],
          },
          {
            id: 'quotesDocuments',
            label: 'Quote Documents',
            type: 'link',
            path: '/quotes/documents',
            groups: ['admin', 'root'],
          },
          {
            id: 'quoteTemplates',
            label: 'Quote Templates',
            type: 'link',
            path: '/quotes/templates/quote-templates',
            groups: ['admin', 'root'],
          },
          {
            id: 'sectionTemplates',
            label: 'Quote Section Templates',
            type: 'link',
            path: '/quotes/templates/section-templates',
            groups: ['admin', 'root'],
          },
          {
            id: 'divider-2',
            label: '',
            type: 'divider',
            groups: ['user', 'admin', 'root'],
          },
          {
            id: 'quopteRates',
            label: 'Quote Rates',
            type: 'link',
            path: '/quotes/rates/setup',
            groups: ['admin', 'root'],
          },
        ],
      },
      {
        id: 'parts',
        label: 'Parts',
        type: 'group',
        path: '/parts',
        icon: 'construction',
        iconType: 'font',
        groups: ['user', 'admin', 'root'],
        children: [
          {
            id: 'partsList',
            label: 'Parts',
            type: 'link',
            path: '/parts/list',
            groups: ['user', 'admin', 'root'],
          },
          {
            id: 'partGroups',
            label: 'Groups',
            type: 'link',
            path: '/parts/groups',
            groups: ['user', 'admin', 'root'],
          },
          {
            id: 'partConfigurations',
            label: 'Configurations',
            type: 'link',
            path: '/parts/configurations',
            groups: ['user', 'admin', 'root'],
          },
          {
            id: 'divider-3',
            label: '',
            type: 'divider',
            groups: ['user', 'admin', 'root'],
          },
          {
            id: 'partsManufacturers',
            label: 'Manufacturers',
            type: 'link',
            path: '/parts/manufacturer',
            groups: ['user', 'admin', 'root'],
          },
          {
            id: 'partSuppliers',
            label: 'Suppliers',
            type: 'link',
            path: '/parts/supplier',
            groups: ['user', 'admin', 'root'],
          },
        ],
      },
      {
        id: 'maintenance',
        label: 'Maintenance',
        type: 'link',
        path: '/maintenance',
        icon: 'engineering',
        iconType: 'font',
        groups: ['user', 'admin', 'root'],
      },
      {
        id: 'customers',
        label: 'Customers',
        type: 'link',
        path: '/customers',
        icon: 'location_city',
        iconType: 'font',
        groups: ['admin', 'root'],
      },
      {
        id: 'users',
        label: 'Users',
        type: 'group',
        icon: '/svg/users.svg',
        iconType: 'url',
        groups: ['admin', 'root'],
        children: [
          {
            id: 'userList',
            label: 'Users',
            type: 'link',
            path: '/users/list',
            groups: ['admin', 'root'],
          },
          {
            id: 'userGroup',
            label: 'Groups',
            type: 'link',
            path: '/users/groups',
            groups: ['admin', 'root'],
          },
        ],
      },
    ];

    return items;
  }
}
